var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"report-item"},[_c('h3',[_vm._v(_vm._s(_vm.report.title))]),_c(_vm.getReportOption.component,_vm._b({tag:"component",staticClass:"report-item__content",class:_vm.getReportOption.class},'component',_vm.getReportOption.props(_vm.report.content),false))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }